import { render, staticRenderFns } from "./CreateForumReply.vue?vue&type=template&id=1cd4626a&"
import script from "./CreateForumReply.vue?vue&type=script&lang=js&"
export * from "./CreateForumReply.vue?vue&type=script&lang=js&"
import style0 from "./CreateForumReply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports